import { render, staticRenderFns } from "./ConfirmationPending.vue?vue&type=template&id=1a27d2f3&"
import script from "./ConfirmationPending.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationPending.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
installComponents(component, {VDivider,VOtpInput})
